"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reducers_1 = require("./reducers");
var utils_1 = require("./utils");
var createRouter = function (routes) {
    var state = {
        params: {},
        route: '',
        matchedRoute: '',
        currentTitle: '',
        routes: {},
        titleGetters: {},
        changeListeners: [],
    };
    var setParams = function (params) {
        state.params = params;
    };
    var setRoute = function (route) {
        state.route = route;
    };
    var setMatchedRoute = function (route) {
        state.matchedRoute = route;
    };
    var setCurrentTitle = function (title) {
        state.currentTitle = title;
    };
    var removeHash = function () {
        history.replaceState(null, document.title, ' ');
    };
    var syncWithHash = function () {
        var hash = location.hash;
        var _a = utils_1.getRouteAndParamsFromHash(hash, Object.keys(state.routes)), route = _a.route, routePattern = _a.routePattern, params = _a.params, reconstructedHash = _a.reconstructedHash;
        setParams(params);
        setRoute(route);
        setMatchedRoute(state.routes[routePattern]);
        setCurrentTitle(state.titleGetters[routePattern](params));
        if (reconstructedHash === '#') {
            removeHash();
        }
        else {
            history.replaceState(undefined, document.title, reconstructedHash);
        }
        document.title = state.currentTitle;
    };
    var callChangeListeners = function () {
        state.changeListeners.forEach(function (changeListener) {
            changeListener({
                route: state.route,
                matchedRoute: state.matchedRoute,
                params: state.params,
            });
        });
    };
    // Public methods
    var setRoutes = function (routes) {
        state = reducers_1.handleSetRoutes(state, routes);
        syncWithHash();
    };
    var navigateTo = function (route) {
        location.hash = "#" + route;
    };
    // TODO: Consider removing this
    var refresh = function () {
        syncWithHash();
        callChangeListeners();
    };
    var addChangeListener = function (changeListenerToBeAdded) {
        state.changeListeners = utils_1.withChangeListener(state.changeListeners, changeListenerToBeAdded);
    };
    var removeChangeListener = function (changeListenerToBeRemoved) {
        state.changeListeners = utils_1.withoutChangeListener(state.changeListeners, changeListenerToBeRemoved);
    };
    // On initialization
    setRoutes(routes);
    window.addEventListener('hashchange', function () {
        syncWithHash();
        callChangeListeners();
    });
    return {
        params: state.params,
        route: state.route,
        matchedRoute: state.matchedRoute,
        currentTitle: state.currentTitle,
        setRoutes: setRoutes,
        navigateTo: navigateTo,
        refresh: refresh,
        addChangeListener: addChangeListener,
        removeChangeListener: removeChangeListener,
    };
};
exports.default = createRouter;
